import { Component } from '@angular/core';

@Component({
  selector: 'app-property-division-success-pj',
  templateUrl: './property-division-success-pj.component.html',
  styleUrls: ['./property-division-success-pj.component.scss'],
})
export class PropertyDivisionSuccessPjComponent {
  // Adicione propriedades e métodos conforme necessário
}
